import React from 'react';
import { Col, Form } from 'react-bootstrap';
import Autocomplete from '@mui/material/Autocomplete';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';

// MultipleCareer Select
const MultipleCareerSelect = ({
  c,
  i,
  ubicacionExists,
  filteredCareers,
  carrerasList,
  selectedCareers,
  handleOptionChange,
  icon,
  checkedIcon
}) => {
  return (
    <Col lg={12} xs={12} className="mb-3" key={'form-bodyform-' + i}>
      <Form.Group>
        <Form.Label>{c.name + ' *'}</Form.Label>
        <Autocomplete
          name="careers"
          multiple
          id="checkboxes-tags-demo"
          className="autocomplete-component"
          options={ubicacionExists ? filteredCareers : carrerasList}
          disableCloseOnSelect
          getOptionLabel={(option) => option.nombre}
          renderOption={(props, option, { selected }) => (
            <li {...props}>
              <Checkbox
                icon={icon}
                checkedIcon={checkedIcon}
                style={{ marginRight: 8 }}
                checked={selected}
              />
              {option.nombre}
            </li>
          )}
          value={selectedCareers}
          onChange={handleOptionChange}
          style={{ width: 500 }}
          noOptionsText="Es necesario seleccionar el lugar donde querés cursar"
          renderInput={(params) => (
            <TextField {...params} placeholder="Busca tu carrera" />
          )}
        />
      </Form.Group>
    </Col>
  );
};

export default MultipleCareerSelect;
